// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  worldId: __t.u64().primaryKey().name("world_id"),
  state: __t.u8(),
  source: __t.u8(),
  genesis: __t.byteArray(),
  jobId: __t.u64().name("job_id"),
  requestedAt: __t.timestamp().name("requested_at"),
  waitUntil: __t.timestamp().name("wait_until"),
  toldAt: __t.option(__t.timestamp()).name("told_at"),
  trouble: __t.string(),
});
